<template>
  <section id="dashboard-ecommerce">
    <div>
      <transaction-view :user-data="userData" />
    </div>
  </section>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'

import { getUserData } from '@/auth/utils'
import { ref } from '@vue/composition-api'
import router from '@/router'
import { kFormatter } from '@core/utils/filter'
import transactionView from '../../components/dashboard/transactions-list/TransactionViewUserInfoCard.vue'
//import { getHomeRouteForLoggedInUser } from '@/auth/utils'
export default {
  components: {
    BRow,
    BCol,
    transactionView,
  },
  data() {
    return {
      stats: {},
      data: {}
    }
  },
  methods: {
    kFormatter,
    //getHomeRouteForLoggedInUser
  },
  setup() {
    const userData = ref(null);
    userData.value = router.currentRoute.params.userData;
    var baseUrl = "/promoimmo";
    var activeItems =[];
    
    return {
      userData,
    }

    function filtreClicked(item) {
      activeItems.push(item);
      urlConstruction()
    }

    // function urlConstruction() {
    //   activeItems.forEach((value, i) => {
    //     if (i == 0) {
    //       baseUrl + "?q" + [i] + "=" + value;
    //     } else {
    //       baseUrl + "&q" + [i] + "=" + value;
    //     }
    //   });
    // }


    
  },
  mounted() {
    // if (getUserData() == null) {
    //   // console.log('ejfkejfk')
    //   this.$router.replace(this.getHomeRouteForLoggedInUser(''))
      
    // }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/dashboard-ecommerce.scss';
@import '@core/scss/vue/libs/chart-apex.scss';
</style>




